'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import Image from 'next/image';

// Emoji data array with image paths
const emojiData = [{
  id: 1,
  image: 'https://media.dinamani.com/dinamani/2026-02-27/6rvq537n/veryhappyemoji.png',
  percentage: 10,
  label: 'Very Happy'
}, {
  id: 2,
  image: 'https://media.dinamani.com/dinamani/2026-02-27/e4j2phh8/happyemoji.png',
  percentage: 9,
  label: 'Happy'
}, {
  id: 3,
  image: 'https://media.dinamani.com/dinamani/2026-02-27/399qazpy/naturalemoji.png',
  percentage: 7,
  label: 'Neutral'
}, {
  id: 4,
  image: 'https://media.dinamani.com/dinamani/2026-02-27/e8elafp6/sademoji.png',
  percentage: 2,
  label: 'Sad'
}, {
  id: 5,
  image: 'https://media.dinamani.com/dinamani/2026-02-27/c0ogrmvw/angry-emoji.png',
  percentage: 3,
  label: 'Angry'
}];
interface EmojiRatingItemProps {
  image: string;
  percentage: number;
  label: string;
  isSelected: boolean;
  onClick: () => void;
}
const EmojiRatingItem: React.FC<EmojiRatingItemProps> = t0 => {
  const $ = _c(10);
  const {
    image,
    percentage,
    label,
    isSelected,
    onClick
  } = t0;
  const t1 = `relative flex flex-col items-center cursor-pointer transition-transform hover:scale-110 ${isSelected ? "scale-110" : ""}`;
  let t2;
  if ($[0] !== percentage) {
    t2 = <div className="absolute w-[28px] h-[28px] sm:w-[35px] sm:h-[35px] -top-[12px] sm:-top-[15px] -right-[8px] sm:-right-[10px] p-1 bg-012061 text-FFFFFF text-12-english-600 sm:text-14-english-600 rounded-full flex items-center justify-center z-10">{percentage}%</div>;
    $[0] = percentage;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== image || $[3] !== label) {
    t3 = <div className="w-[45px] h-[45px] sm:w-[60px] sm:h-[60px] rounded-full flex items-center justify-center transition-all overflow-hidden bg-gray-50 hover:bg-gray-100"><Image src={image} alt={label} width={35} height={35} className="w-full h-full object-contain p-1" /></div>;
    $[2] = image;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onClick || $[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div onClick={onClick} className={t1}>{t2}{t3}</div>;
    $[5] = onClick;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default function EmojiRating() {
  const $ = _c(5);
  const [selectedEmoji, setSelectedEmoji] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = id => {
      setSelectedEmoji(id);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleEmojiClick = t0;
  let t1;
  if ($[1] !== selectedEmoji) {
    t1 = emojiData.map(item => <EmojiRatingItem key={item.id} image={item.image} percentage={item.percentage} label={item.label} isSelected={selectedEmoji === item.id} onClick={() => handleEmojiClick(item.id)} />);
    $[1] = selectedEmoji;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="bg-FFFFFF p-3 sm:p-4 w-full h-[100px] sm:h-[120px] flex items-center"><div className="w-full flex justify-center gap-6 sm:gap-8 md:gap-12 lg:gap-20 items-center px-2 sm:px-4 mt-3">{t1}</div></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}